import PaymentStatus from "../types/paymentStatus.type";

export const paymentStatusNames: Record<string, string> = {
  [PaymentStatus.DRAFT]: "Draft",
  [PaymentStatus.PENDING]: "Pending",
  [PaymentStatus.PROCESSING]: "Processing",
  [PaymentStatus.APPROVED]: "Approved",
  [PaymentStatus.REJECTED]: "Rejected",
  [PaymentStatus.COMPLETED]: "Completed",
  [PaymentStatus.POSTPONED]: "Postponed",
  [PaymentStatus.FAILED]: "Failed",
  [PaymentStatus.CANCELLED]: "Canceled",
};

export const paymentStatusColors: Record<string, string> = {
  [PaymentStatus.DRAFT]: "rgb(145, 148, 150)",
  [PaymentStatus.PENDING]: "rgb(250, 219, 20)",
  [PaymentStatus.PROCESSING]: "rgb(250,173,20)",
  [PaymentStatus.APPROVED]: "rgb(24, 144, 255)",
  [PaymentStatus.REJECTED]: "rgb(207, 19, 34)",
  [PaymentStatus.COMPLETED]: "rgb(82, 196, 26)",
  [PaymentStatus.POSTPONED]: "rgb(145, 148, 150)",
  [PaymentStatus.FAILED]: "rgb(207, 19, 34)",
  [PaymentStatus.CANCELLED]: "rgb(24, 144, 255)",
};

export const isEditable = (status: PaymentStatus) =>
  status === "DRAFT";
